import React from 'react';
import { formatMessage } from 'devextreme/localization';

import FieldColorHelper from '../../tools/FieldColorHelper';
import FieldFlagIcon from '../field-flag-icon/FieldFlagIcon';

import FieldTypeReferenceDto from '../../classes/dtos/FieldTypeReferenceDto';

interface FieldTypeTagProps {
    FieldType: FieldTypeReferenceDto;
}

/**
 * The coloured field-type chip plus its "mandatory" / "primary key" flag icons, shared by every
 * path-editor mapping grid (MetaApi, Reporting, AI, DataTable, and both Synchro cells).
 *
 * The flags are purely informational: they reflect a constraint of the underlying field and are
 * NOT enforced by the pre-save check (see logics/pathmodule/PathBeforeSaveValidation).
 *
 * "Mandatory" is always `FieldTypeReferenceDto.IsRequired` — the single canonical predicate — so
 * the icon can never drift between grids again (Synchro's source cell used to compute its own).
 */
export default function FieldTypeTag({ FieldType }: FieldTypeTagProps) {
    const tagColor = FieldColorHelper.GetTagColor(FieldType.Type);
    const textColor = FieldColorHelper.GetTextColor(FieldType.Type);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 'auto', height: 22, paddingLeft: 10, paddingRight: 10, paddingTop: 2, paddingBottom: 2, background: tagColor, borderRadius: 16, justifyContent: 'center', alignItems: 'center', gap: 6, display: 'inline-flex' }}>
                <div style={{ textAlign: 'center', color: textColor, fontSize: 10, fontFamily: 'Manrope', fontWeight: '500', textTransform: 'uppercase', letterSpacing: 1, wordWrap: 'break-word' }}>{FieldType.TypeLabel}</div>
            </div>
            {FieldType.IsRequired && (
                <FieldFlagIcon src="svgs/mandatory.svg" alt="mandatory" hint={formatMessage('FieldTypeCell_RequiredHint')} />
            )}
            {FieldType.IsPrimaryKey && (
                <FieldFlagIcon src="svgs/primarykey.svg" alt="primary key" hint={formatMessage('FieldTypeCell_PrimaryKeyHint')} />
            )}
        </div>
    );
}
